import db from "@app/firebase/firebase";
import {
  QuerySnapshot,
  collection,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";

export const listenForNotificationChanges = (
  callback: (snapshot: QuerySnapshot) => void,
) => {
  const q = query(collection(db, "notification"), orderBy("date", "desc"));
  return onSnapshot(q, (querySnapshot) => callback(querySnapshot));
};
